import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/reset.css";
import "./assets/styles/App.module.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import awsconfig from "./aws-exports";
import { Amplify } from "aws-amplify";
import { Helmet } from "react-helmet";
Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Helmet>
      <title>適性テスト</title>
    </Helmet>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
